import React, { FC, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import { ProjectCreateContainer } from 'modules/ProjectCreate/components'
import { FormInput, FormSelect } from 'components/FormWithGroup'
import { getArtistCreateRules } from 'modules/ProjectCreate/constants/rules'
import { ArtistAvatar } from 'components'
import { IArtistCreateProps } from './ArtistCreate.props'
import './ArtistCreate.scss'

const ArtistCreate: FC<IArtistCreateProps> = ({ gpsUnits, labelOptions, artistList }) => {
  const { control } = useFormContext()

  const rules = useMemo(() => getArtistCreateRules(artistList), [artistList])

  return (
    <ProjectCreateContainer className="artist-create__container">
      <section className="artist-create__avatar-container">
        <h3 className="artist-create__title">Create Artist</h3>
        <ArtistAvatar className="artist-create__avatar" facebookId="" spotifyId="" size="s" isImage />
      </section>
      <section>
        <FormInput
          label="Artist"
          control={control}
          fieldName="artistName"
          placeholder="Artist Name"
          rules={rules.artistName}
        />
        <FormSelect
          label="Origin"
          control={control}
          fieldName="firstCreatedIn"
          placeholder="Origin"
          rules={rules.firstCreatedIn}
          options={labelOptions}
        />
      </section>
      <section>
        <FormSelect
          label="GPS Artist Status"
          control={control}
          fieldName="gpsStatus"
          placeholder="Select Status"
          options={gpsUnits}
        />
      </section>
    </ProjectCreateContainer>
  )
}

export default ArtistCreate
